import { Colors, Sizes } from '@/components/ui/types';

import { SelectVariant } from './types';

export const sizeClasses: Record<Sizes, string> = {
  xs: 'select-xs',
  sm: 'select-sm',
  md: 'select-md',
  lg: 'select-lg',
  xl: 'select-xl',
};

export const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'select-neutral',
  primary: 'select-primary',
  secondary: 'select-secondary',
  accent: 'select-accent',
  info: 'select-info',
  success: 'select-success',
  warning: 'select-warning',
  error: 'select-error',
};

export const variantClasses: Record<SelectVariant, string> = {
  default: '',
  ghost: 'select-ghost',
};

export const chipSizeClasses: Record<Sizes, Sizes> = {
  xs: 'xs',
  sm: 'xs',
  md: 'sm',
  lg: 'md',
  xl: 'lg',
};
